import FJErrorIcon from '../../../assets/svg/error.svg?react';
import FJPauseIcon from '../../../assets/svg/pause.svg?react';
import FJPlayIcon from '../../../assets/svg/play.svg?react';
import classNames from 'classnames';
import { useRef, useState, useEffect } from 'react';
import FJUtil from '../../../util/FJUtil.js';
import FJButton from '../../../common/components/FJButton/FJButton.jsx';
import FJDropdownNew from '../../../common/components/FJDropDown/FJDropdownNew.jsx';
import MoreIcon from '../../../assets/svg/more.svg?react';
import FJSelectItemsIcon from '../../../assets/svg/select-items.svg?react';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJDeleteIcon from '../../../assets/svg/delete-black.svg?react';
import FJEditIcon from '../../../assets/svg/ttv/edit.svg?react';
import styles from './FJVoiceCloningItem.module.less';
import FJCheckBox from '../../../common/components/FJCheckBox/FJCheckBox.jsx';
import FJConfig from '../../../config/FJConfig.js';
import FJAudioPlayManager from '../../../store/FJAudioPlayManager.js';
import FJMessageStore from '../../../store/FJMessageStore.js';
import FJTextWithEllipsis from '../../../common/components/FJTextWithEllipsis/FJTextWithEllipsis.jsx';
import PropTypes from 'prop-types';
const FJVoiceCloningItem = props => {
    const {
        onSelected,
        id,
        name,
        avatar,
        isMultipleMode,
        enterMultiple,
        deleteVoice,
        editVoice,
        isSelected,
        showLang,
        audioUrl,
        onUse,
    } = props;
    const [isCoverError, setIsCoverError] = useState(false);
    const [isShowDropDown, setIsShowDropDown] = useState(false);

    const [isPlay, setIsPlay] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [useAudioUrl, setUseAudioUrl] = useState(audioUrl);
    const audioRef = useRef(null);
    const idRef = useRef(FJAudioPlayManager.createId());

    const thumUrl = FJConfig.profilePath + avatar + '.png';

    useEffect(() => {
        setIsCoverError(false);
    }, [avatar]);
    const _onCoverError = () => {
        setIsCoverError(true);
    };

    const _forbidEvent = e => {
        FJUtil.forbidEvent(e);
    };

    const _onSelected = (bool, e) => {
        onSelected && onSelected(id, bool, e);
    };

    const _onShow = () => {
        setIsShowDropDown(true);
    };

    const _onHide = () => {
        setIsShowDropDown(false);
    };

    const _onEnded = () => {
        setIsPlay(false);
        pause();
    };

    const _onError = () => {
        setIsError(true);
        setIsLoading(false);
        if (isPlay) {
            setIsPlay(false);
            FJMessageStore.addMessage(FJLocalStore._('playback-failed-please-try-again'), 'error');
        }
    };

    const _onLoadedData = () => {
        setIsError(false);
        setIsLoading(false);
    };

    const _onLoadStart = () => {
        setIsLoading(true);
        setIsError(false);
        if (isPlay) {
            play();
        }
    };

    const _changePlay = e => {
        e.stopPropagation();
        setIsPlay(!isPlay);
        if (isPlay) {
            pause();
        } else {
            if (isError) {
                setIsLoading(true);
                setUseAudioUrl(FJUtil.getReloadNewUrl(audioUrl));
            } else {
                play();
            }
        }
    };

    const play = () => {
        FJAudioPlayManager.add(idRef.current, { pause: pause });
        audioRef.current?.play();
        setIsPlay(true);
    };

    const pause = () => {
        if (audioRef.current) {
            audioRef.current?.pause();
        }
        audioRef.current = null;
        setIsPlay(false);
    };

    const _renderTrigger = config => {
        return (
            <div onClick={config.onClick} ref={config.ref}>
                <FJButton icon={<MoreIcon />} className={styles.icon_btn} type='white' />
            </div>
        );
    };

    const _renderOverlay = config => {
        return (
            <div className={styles.detail_box} ref={config.ref}>
                <div className={styles.item_btn} onClick={editVoice}>
                    <FJEditIcon />
                    {FJLocalStore._('edit')}
                </div>
                <div className={styles.item_btn} onClick={enterMultiple}>
                    <FJSelectItemsIcon />
                    {FJLocalStore._('select')}
                </div>
                <div className={styles.item_btn} onClick={deleteVoice}>
                    <FJDeleteIcon />
                    {FJLocalStore._('delete')}
                </div>
            </div>
        );
    };

    return (
        <div className={classNames(styles.box, isShowDropDown ? styles.active : '')}>
            <div className={styles.left}>
                <div className={styles.control}>
                    <img className={styles.img} src={thumUrl} onError={_onCoverError} alt='' />
                    {isCoverError && (
                        <div className={classNames(styles.bk_mask, styles.cover_error)}>
                            <FJErrorIcon />
                        </div>
                    )}
                    <div className={styles.play_box} onClick={_changePlay} onMouseDown={_forbidEvent}>
                        {isLoading && <div className={styles.loading} />}
                        {isPlay && <FJPauseIcon />}
                        {!isPlay && <FJPlayIcon />}
                        {isPlay && (
                            <audio
                                src={useAudioUrl}
                                ref={audioRef}
                                onEnded={_onEnded}
                                onError={_onError}
                                onLoadedData={_onLoadedData}
                                onLoadStart={_onLoadStart}
                                preload='metadata'
                            />
                        )}
                    </div>
                </div>
                <FJTextWithEllipsis className={styles.name} text={name} />
            </div>

            <div className={styles.language}>{showLang}</div>

            <div className={styles.right}>
                <div className={classNames(styles.btn_box, isMultipleMode ? styles.multiple : '')}>
                    <FJButton className={styles.use_btn} type='gradient' text='use' onClick={onUse} />
                    <FJDropdownNew
                        isTopLayer={true}
                        renderTrigger={_renderTrigger}
                        useAnchorBody
                        placement='bottomRight'
                        renderOverlay={_renderOverlay}
                        offsetTop={6}
                        onShow={_onShow}
                        onHide={_onHide}
                    />
                </div>
                {isMultipleMode && (
                    <FJCheckBox selected={isSelected} dataChange={_onSelected} className={styles.check} />
                )}
            </div>
        </div>
    );
};

FJVoiceCloningItem.propTypes = {
    onSelected: PropTypes.func,
    id: PropTypes.string,
    name: PropTypes.string,
    avatar: PropTypes.string,
    isMultipleMode: PropTypes.bool,
    enterMultiple: PropTypes.func,
    deleteVoice: PropTypes.func,
    editVoice: PropTypes.func,
    isSelected: PropTypes.bool,
    showLang: PropTypes.string,
    audioUrl: PropTypes.string,
    onUse: PropTypes.func,
};
export default FJVoiceCloningItem;
